export default __webpack_public_path__ + "static/media/servipag-color.4ca990d4.svg";